import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=1205cb4a&scoped=true"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Collapse.vue?vue&type=style&index=0&id=1205cb4a&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1205cb4a",
  null
  ,true
)

export default component.exports